import { biaIpTypeOptions } from "@/common/const";
import {
  customerCurrency,
  wiaAccessTechOptions,
} from "@/common/const/filter-options";
import { wiaInterfaceType } from "@/common/const/filter-options/wiaInterfaceType.options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const wiaQuoteLineFormStrategy: FormFieldsStrategyType[] = [
  {
    label: "Currency",
    name: "targetCurrency",
    required: false,
    readonly: true,
    inputType: "select",
    options: customerCurrency,
  },
  {
    inputType: "text",
    label: "OTC",
    name: "targetOTC",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "MRC",
    name: "targetMRC",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "Quote Type",
    required: false,
    readonly: true,
    name: "quoteType",
  },
  {
    inputType: "select",
    label: "CPE",
    name: "CPE",
    required: false,
    readonly: true,
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
  {
    inputType: "text",
    label: "Last Mile Provider",
    name: "lastMileProvider",
    required: false,
    readonly: true,
  },

  {
    inputType: "text",
    label: "Download Speed (in Mbps)",
    name: "downloadSpeed",
    required: false,
    readonly: true,
    patternMessage: "Value not satisfied range from 0.128 to 10,000",
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    inputType: "text",
    label: "Upload Speed (in Mbps)",
    name: "uploadSpeed",
    required: false,
    readonly: true,
    patternMessage: "Value not satisfied range from 0.128 to 10,000",
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    inputType: "select",
    label: "Data Limit Type",
    name: "dataLimitType",
    required: false,
    readonly: true,
    options: [
      {
        label: "Capped",
        value: "capped",
      },
      {
        label: "Unlimited",
        value: "unlimited",
      },
    ],
  },
  {
    inputType: "text",
    label: "Data Limit (in GB)",
    name: "dataLimitGB",
    required: false,
    readonly: true,
  },

  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: false,
    readonly: true,
    options: [...contractTermsOptions],
  },

  {
    inputType: "select",
    label: "Access Technology",
    name: "AccessTechnology",
    required: false,
    readonly: true,
    options: wiaAccessTechOptions,
  },
  {
    inputType: "select",
    label: "Interface/Handoff Type",
    name: "interface",
    required: false,
    readonly: true,
    options: wiaInterfaceType,
  },
  {
    inputType: "select",
    label: "IP",
    name: "IP",
    required: false,
    readonly: true,
    options: biaIpTypeOptions,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "SLA Uptime (in %)",
    name: "SlaUptime",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "SLA MTTR (in Hours)",
    name: "SlaMTTR",
    required: false,
    readonly: true,
  },
  {
    inputType: "select",
    label: "Network Status",
    name: "networkStatus",
    required: false,
    readonly: true,
    options: [
      {
        label: "Off Net",
        value: "OfNet",
      },
      {
        label: "Near Net",
        value: "NearNet",
      },
      {
        label: "On Net",
        value: "OnNet",
      },
    ],
  },
  {
    inputType: "textarea",
    label: "Note",
    name: "description",
    required: false,
  },
];
export default wiaQuoteLineFormStrategy;
